import React, { useEffect, useState } from "react";
import { apiList } from "../../helpers/apiList";
import { axiosPostApi } from "../../helpers/interceptorServices";
import CustomAlert from "../../helpers/CustomAlert";
import { CircularProgress } from "@mui/material";

const ServicesPermissionModal = ({ isOpen, onClose, columnData, callApi }) => {
  const initialMenu = columnData?.userMenu;
  const loggedInUserName = sessionStorage.getItem("username");

  const services = [
    { name: "SMS Service", indexes: [25], disabled: true },
    { name: "RCS Service", indexes: [26, 68, 69, 70, 71] },
    { name: "Courier Service", indexes: [61, 66, 72] },
    { name: "Recharge/BBPS Service", indexes: [60, 73] },
    { name: "Bill Payment Service", indexes: [74] },
  ];
  const [menuArray, setMenuArray] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setMenuArray(initialMenu.split(""));
  }, [initialMenu]);

  const handleToggle = (service) => {
    const updatedMenu = [...menuArray];

    const isCurrentlyEnabled = updatedMenu[service.indexes[0]] === "1";

    service.indexes.forEach((idx) => {
      updatedMenu[idx] = isCurrentlyEnabled ? "0" : "1";
    });

    setMenuArray(updatedMenu);
  };

  const isChecked = (indexes) => {
    return indexes.some((idx) => menuArray[idx] === "1");
  };

  const handleAuthorizeMenu = async (updatedMenuStr) => {
    setLoading(true);
    try {
      const payload = {
        username: loggedInUserName,
        companyId: columnData.customerCode || "",
        companyName: columnData?.name || "",
        userMenu: updatedMenuStr || "",
      };

      const response = await axiosPostApi(
        `${apiList.COMPANY_UPDATE_USER_MENU}`,
        payload
      );

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        CustomAlert({
          title: "Success",
          text: response?.data?.message,
          icon: "success",
          confirmButtonText: "Ok",
        });
        onClose();
        callApi();
      } else {
        CustomAlert({
          title: "Failed",
          text:
            response?.data?.message ||
            "There was an issue processing the request.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text:
          error.response?.data?.message ||
          "An error occurred while fetching the RCS history data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = () => {
    const updatedMenuStr = menuArray.join("");
    handleAuthorizeMenu(updatedMenuStr);
  };

  if (!isOpen) return null;
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: "rgba(0,0,0,0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1031,
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "10px",
          width: "400px",
          padding: "20px",
          position: "relative",
        }}
      >
        {/* Modal header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "20px",
            borderBottom: "1px solid #dee2e6",
            paddingBottom: "1rem",
          }}
        >
          <div
            style={{
              width: "40px",
              height: "40px",
              backgroundColor: "#e8f0fe",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "10px",
            }}
          >
            🔒
          </div>
          <div>
            <h5 className="modal-title main-title" style={{ fontSize: "20px" }}>
              View Permission / Operation
            </h5>
            {/* <div style={{ fontSize: "14px", color: "#555" }}>
              prakash kumar Retailer A
            </div> */}
          </div>
        </div>

        {/* Checkbox options */}
        <div style={{ marginBottom: "20px" }}>
          {services.map((service) => (
            <div
              key={service.name}
              style={{ marginBottom: "10px", display: "flex" }}
            >
              <input
                type="checkbox"
                id={service.name}
                checked={isChecked(service.indexes)}
                onChange={() => !service.disabled && handleToggle(service)}
                disabled={service?.disabled}
                style={{ cursor: service.disabled ? "not-allowed" : "pointer" }}
              />
              <label
                htmlFor={service.name}
                style={{
                  marginLeft: "8px",
                  fontSize: "14px",
                  color: service.disabled ? "#6c757d" : "#212529",
                  cursor: service.disabled ? "not-allowed" : "pointer",
                }}
              >
                {service.name}
              </label>
            </div>
          ))}
        </div>

        {/* Buttons */}
        <div
          className="scoped-modal"
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "12px 0px",
            gap: "16px",
            borderTop: "1px solid #dee2e6",
          }}
        >
          <button type="button" className="btn btn-back" onClick={onClose}>
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-submit"
            style={{
              cursor: loading ? "not-allowed" : "pointer",
            }}
            disabled={loading}
            onClick={handleSubmit}
          >
            {loading ? (
              <CircularProgress style={{ width: "20px", height: "20px" }} />
            ) : (
              "Submit"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServicesPermissionModal;
